import { h } from "preact";
import { Input, Button } from "antd";

const FILTER_VARIANTS = {
  flowId: {
    searchKey: "searchByFlowID",
    currentKey: "currentFlowID",
  },
  personId: {
    searchKey: "searchByPersonID",
    currentKey: "currentPersonID",
  },
  iin: {
    searchKey: "searchByIIN",
    currentKey: "currentIIN",
  },
};

function FilterContentBy({ variant, value, onChange, onApply, minLength }) {
  const isTooShort = value.length < (minLength || 1);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      <Input
        onChange={(e) => onChange(e.target.value)}
        value={value}
      />
      {minLength && (
        <span style={{ fontSize: "12px", color: isTooShort ? "#ff4d4f" : "#8c8c8c" }}>
          Min. {minLength} characters
        </span>
      )}
      <Button type="primary" onClick={onApply} disabled={isTooShort}>Apply</Button>
    </div>
  );
}

FilterContentBy.VARIANTS = FILTER_VARIANTS;

export default FilterContentBy;
